var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DsCard',[_c('header',{staticClass:"card-header"},[_c('h5',[_vm._v(" Latest comments ")])]),_c('CommentsList',{attrs:{"comments":_vm.sortedComments}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }